import { RaceEventSharePopup } from '../views/RaceEventSharePopup';
import { preloadLayoutsAssets } from '../../../views/preloadLayoutsAssets';
import type { RaceEventDependencies } from '../RaceEventController';

export async function openRaceEventSharePopup(dependencies: RaceEventDependencies, rank: number): Promise<void> {
  const { popupsController, shareImage } = dependencies;

  if (!shareImage) return Promise.resolve();

  if (!(await preloadLayoutsAssets(RaceEventSharePopup.requiredLayouts, true))) return Promise.resolve();

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  const popup = new RaceEventSharePopup(rank);

  popup.onClose.connect((): void => {
    void popupsController.closeActivePopup();
    resolve();
  });

  popup.onShare.connect(async (imagePromise): Promise<void> => {
    void shareImage(imagePromise);
  });

  void popupsController.addPopup(popup);

  return promise;
}
